import { __ } from "@wordpress/i18n";
import Hint from '../components/Hint/Hint';
import Switch from '../components/Switch/Switch';
import { useMenu } from '../contexts/MenuContext';
import withForm from '../layouts/withForm';
const RecommendationsScripts = ({handleChange}) => {
    const {
        settingData
    } = useMenu();
    return (
        <>
            <div className="setting-unit">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Script & Styles", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Includes script and styles-related policies you can apply.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">

                        <div className="row justify-content-between">                                    
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Hide CSS File Version", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.hide_css_file_version"
                                    checked={settingData?.security?.recommendations?.hide_css_file_version} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">                                    
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Hide JS File Version", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.hide_js_file_version"
                                    checked={settingData?.security?.recommendations?.hide_js_file_version} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">                                    
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Disable Dashicons in Frontend", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.disable_dashicons_in_frontend"
                                    checked={settingData?.security?.recommendations?.disable_dashicons_in_frontend} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">                                    
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Disable Embeds", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.disable_embeds"
                                    checked={settingData?.security?.recommendations?.disable_embeds} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">                                    
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable Strict Content Security Policy.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">
                                        <a href="https://web.dev/articles/strict-csp" target="_blank" rel="noopener noreferrer">{__("Strict Content Security Policy", "ultimate-security")}</a>
                                        {__(" on the frontend and login screen", "ultimate-security")}
                                    </h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.strict_content_security_policy"
                                    checked={settingData?.security?.recommendations?.strict_content_security_policy} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}
export default withForm(RecommendationsScripts, 'security.recommendations');